import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Configuration } from 'src/app/app.constants';
import { FilterViewModel } from '../models/filter/filterViewModel';

@Injectable({
  providedIn: 'root',
})
export class HistoryFiltersService {

  constructor(private http: HttpClient, private configuration: Configuration) {
    
  }

  /**
   * Getter that dynamically builds the url each time.
   * This ensures the URL updates when the backend API changes (e.g., account switching).
   */
  private get url(): string {
    return this.configuration.buildEndpoint(`Filters/`);
  }

  /**
   * Get Filters used in history filtrations
   */
  public getHistoryFilters(): Observable<FilterViewModel[]> {
    return this.http.post<FilterViewModel[]>(`${this.url}historyFilters`, {});
  }
}
